import { token } from '@atlaskit/tokens';

export const keylineHeight = 2;
export const keylineColor = token('color.border');
